import React from 'react';


const MonthView = ({ 
  currentDate, 
  events, 
  onDateClick, 
  onEventClick, 
  language 
}) => {
  const getDaysInMonth = (date) => {
    const year = date?.getFullYear();
    const month = date?.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay?.getDate();
    const startingDayOfWeek = firstDay?.getDay();

    return { daysInMonth, startingDayOfWeek, year, month };
  };

  const { daysInMonth, startingDayOfWeek, year, month } = getDaysInMonth(currentDate);

  const dayNames = {
    en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    fr: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    ar: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
  };

  const days = dayNames?.[language] || dayNames?.en;

  const getEventsForDate = (day) => {
    const dateStr = `${year}-${String(month + 1)?.padStart(2, '0')}-${String(day)?.padStart(2, '0')}`;
    return events?.filter(event => event?.date === dateStr);
  };

  const isToday = (day) => {
    const today = new Date();
    return (day === today?.getDate() &&
    month === today?.getMonth() && year === today?.getFullYear());
  };

  const renderCalendarDays = () => {
    const cells = [];
    
    for (let i = 0; i < startingDayOfWeek; i++) {
      cells?.push(
        <div key={`empty-${i}`} className="min-h-[100px] md:min-h-[120px] bg-muted/30" />
      );
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const dayEvents = getEventsForDate(day);
      const today = isToday(day);

      cells?.push(
        <div
          key={day}
          onClick={() => onDateClick(new Date(year, month, day))}
          className={`min-h-[100px] md:min-h-[120px] border border-border p-2 cursor-pointer hover:bg-muted/50 transition-colors ${
            today ? 'bg-primary/5 border-primary' : 'bg-card'
          }`}
        >
          <div className={`text-sm font-medium mb-2 ${
            today ? 'text-primary' : 'text-foreground'
          }`}>
            {day}
          </div>
          <div className="space-y-1">
            {dayEvents?.slice(0, 3)?.map((event) => (
              <div
                key={event?.id}
                onClick={(e) => {
                  e?.stopPropagation();
                  onEventClick(event);
                }}
                className={`text-xs px-2 py-1 rounded truncate cursor-pointer hover:opacity-80 transition-opacity ${
                  event?.type === 'hearing' ? 'bg-error/10 text-error' :
                  event?.type === 'appointment' ? 'bg-primary/10 text-primary' :
                  event?.type === 'deadline'? 'bg-warning/10 text-warning' : 'bg-success/10 text-success'
                }`}
              >
                {event?.time} {event?.title}
              </div>
            ))}
            {dayEvents?.length > 3 && (
              <div className="text-xs text-muted-foreground px-2">
                +{dayEvents?.length - 3} {language === 'fr' ? 'plus' : language === 'ar' ? 'المزيد' : 'more'}
              </div>
            )}
          </div>
        </div>
      );
    }

    return cells;
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="grid grid-cols-7 border-b border-border">
        {days?.map((day, index) => (
          <div
            key={index}
            className="p-3 text-center text-sm font-semibold text-muted-foreground bg-muted/50"
          >
            {day}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7">
        {renderCalendarDays()}
      </div>
    </div>
  );
};

export default MonthView;